import React from 'react'
import Footer from '../components/Footer'
import ServicesSection from '../components/ServicesSection'

const Works = () => {
  return (
    <div>
        <ServicesSection showAll={true} title='Works' marginTop='mt-24' />
        <Footer />
    </div>
  )
}

export default Works